import { Spinner } from "@/components/common/Spinner";
import {
	TREE_INDENT_PX,
	TREE_ROOT_PADDING_PX,
	TreeIndentGuides,
} from "@/components/file-tree/TreeIndentGuides";
import { ROW_HOVER_CLASS } from "@/lib/row-styles";

interface SharedVolumeLoadMoreRowProps {
	/** 続きを読むディレクトリの行のキー。 */
	directoryKey: string;
	depth: number;
	loading: boolean;
	onClick: () => void;
}

/** 共有ボリュームのディレクトリの直下の続きを読む行。 */
export function SharedVolumeLoadMoreRow({
	directoryKey,
	depth,
	loading,
	onClick,
}: SharedVolumeLoadMoreRowProps) {
	return (
		<button
			type="button"
			onClick={onClick}
			disabled={loading}
			className={`relative flex min-h-[22px] w-full min-w-0 cursor-pointer items-center py-0.5 text-left text-list text-fg-2 ${ROW_HOVER_CLASS}`}
			style={{ paddingLeft: depth * TREE_INDENT_PX + TREE_ROOT_PADDING_PX + TREE_INDENT_PX }}
			data-testid={`shared-volume-load-more-${directoryKey}`}
		>
			<TreeIndentGuides depth={depth} />
			{loading ? <Spinner /> : "さらに表示"}
		</button>
	);
}
